export default __webpack_public_path__ + "static/media/gallery_08.0058156c.jpg";